import styled from 'styled-components';

export const ProductsSearchResultsContainer = styled.section<{
  headerHeight: number;
}>`
  background-color: ${({ theme }) => theme.colorsPalette.gray.superLight};
  padding-top: ${({ headerHeight }) => headerHeight + 52}px;
  position: relative;
`;
